<template>
  <div class="google-oauth-callback">
    <div class="callback-card">
      <spinner v-if="loading" />
      <div v-else-if="error" class="error-state">
        <h2>{{ adminText('adminAll.google_sign_in_failed_44c242', 'Google sign-in failed') }}</h2>
        <p>{{ adminAllMessage(error) }}</p>
        <button class="retry-button" @click="navigateHome">{{ adminText('adminAll.return_to_home_9ca41a', 'Return to home') }}</button>
      </div>
      <div v-else class="success-state">
        <h2>{{ adminText('adminAll.signing_in_c66b2a', 'Signing in…') }}</h2>
        <p>{{ adminText('adminAll.redirecting_you_back_to_the_application_5ef63c', 'Redirecting you back to the application.') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
import { mapActions } from 'vuex'
import Spinner from '@/components/shared/spinner.vue'
import { GOOGLE_LOGIN } from '@/graphql/auth.graphql'

export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'google-oauth-callback',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  created() {
    this.handleAuthorizationResponse()
  },
  methods: {
    ...mapActions({
      fetchUser: 'auth/fetchUser',
    }),
    async handleAuthorizationResponse() {
      const { code, state, error, error_description: errorDescription } = this.$route.query
      if (error) {
        this.error = errorDescription || error
        this.loading = false

        return
      }
      if (!code) {
        this.error = this.adminAllNotice('Missing authorization code. Please try signing in again.')
        this.loading = false

        return
      }
      try {
        const { errors } = await this.$apollo.mutate({
          mutation: GOOGLE_LOGIN,
          variables: { authorizationCode: code, usePostmessage: false },
        })
        if (errors && errors.length) {
          throw new Error(errors[0].message)
        }
        await this.fetchUser()
        const redirectTarget = this.getRedirectPath(state)
        this.$router.replace(redirectTarget)
      } catch (e) {
        this.error = e.message || this.adminAllNotice('Unable to complete Google sign-in. Please try again.')
        this.loading = false
      }
    },
    getRedirectPath(state) {
      const stored = this.getStoredRedirectPath()
      if (stored) {
        return stored
      }

      return this.resolveState(state)
    },
    getStoredRedirectPath() {
      try {
        const storedPath = sessionStorage.getItem('coreevent_google_redirect_path')
        if (!storedPath) {
          return null
        }
        sessionStorage.removeItem('coreevent_google_redirect_path')

        return this.sanitizePath(storedPath)
      } catch (e) {
        return null
      }
    },
    resolveState(state) {
      if (!state) {
        return '/'
      }
      try {
        return this.sanitizePath(state)
      } catch (e) {
        return '/'
      }
    },
    sanitizePath(value) {
      if (!value) {
        return '/'
      }
      let decoded = value
      try {
        decoded = decodeURIComponent(decoded)
      } catch (e) {
        // ignore
      }
      if (decoded.startsWith('%2F')) {
        try {
          decoded = decodeURIComponent(decoded)
        } catch (e) {
          decoded = '/'
        }
      }
      if (!decoded.startsWith('/')) {
        return '/'
      }

      return decoded
    },
    navigateHome() {
      this.$router.replace('/')
    },
  },
}
</script>

<style scoped>
.google-oauth-callback {
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 24px;
}

.callback-card {
  max-width: 420px;
  width: 100%;
  padding: 32px;
  border-radius: 16px;
  background: #fff;
  text-align: center;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
}

.error-state h2,
.success-state h2 {
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.error-state p,
.success-state p {
  margin-bottom: 24px;
  color: #555;
  line-height: 1.5;
}

.retry-button {
  padding: 10px 20px;
  border-radius: 24px;
  border: none;
  cursor: pointer;
  background: #333;
  color: #fff;
  font-weight: 600;
}

.retry-button:hover {
  background: #111;
}
</style>
